import React from "react";

class Header extends React.Component {
  render() {
    return (
      <React.Fragment>
        {" "}
        <header id="home">
          <div className="container text-center text-header">
            <p>Welcome to</p>

            <h1>Shawn Douglas Hair</h1>

            <p>Beauty Professional | Orange County, CA.</p>
            <br />
          </div>
        </header>
      </React.Fragment>
    );
  }
}
export default Header;
